<template>
  <SelectInputView :title="title" :options="filteredOptions" searchable :value="value" :required="required" :multiple="multiple" :disabled="disabled" :max="max" :size="size" :errors="errors" v-model:query="query" @update:value="$emit('update:value', $event)">
    <template v-slot:option="{ option, preview }">
      <slot name="option" :option="option" :preview="preview"></slot>
    </template>
  </SelectInputView>
</template>

<script setup>
import SelectInputView from "./SelectInputView.vue";
import {computed, ref} from "vue";

const props = defineProps({
  title: String,
  options: Array,
  value: [Number, String, Boolean, Array],
  required: Boolean,
  multiple: Boolean,
  disabled: Boolean,
  max: Number,
  size: String,
  errors: Array,
  filter: {
    type: Function,
    required: true
  }
});

const emit = defineEmits(["update:value"]);

const query = ref("");

const filteredOptions = computed(() => {
  if (query.value.length === 0) return props.options;
  if (props.options.length > 0) {
    return props.options.filter(item => props.filter({ query: query.value, item: item }));
  } else {
    return [];
  }
});

</script>